import { simplifyQueryValue } from 'js/lib/queryUtils';
import { useLocation } from 'js/lib/useRouter';

export const useArticlesDirectoryUrlData = () => {
  const { pathname, query } = useLocation();
  const { page, preview = 0 } = query;

  const localeCodeFromQuery: string | undefined = simplifyQueryValue(query.localeCode);
  const pageNumber = parseInt(simplifyQueryValue(page) ?? '1', 10);
  const isPreview = !!preview && Number(preview) === 1;

  return {
    pathname,
    pageNumber,
    isPreview,
    localeCodeFromQuery,
  };
};
